import React, { useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        note: "",
    });

    const [loading, setLoading] = useState(false);
    const [, forceUpdate] = useState();
    const validator = useRef(new SimpleReactValidator());

    // handle input change
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // allow only digits for phone
    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setForm({ ...form, phone: value });
    };

    // submit form
    const handleSubmit = (e) => {
        e.preventDefault();

        if (validator.current.allValid()) {
            setLoading(true);

            emailjs
                .send(
                    "service_pfo5mqn", // ✅ your service ID
                    "template_in086pe", // ✅ your template ID
                    {
                        name: form.name,
                        email: form.email,
                        phone: form.phone,
                        subject: form.subject,
                        message: form.note, // ✅ mapped correctly
                    },
                    "fpyTfnxYWyfV2_3Lh" // ✅ your public key
                )
                .then(() => {
                    alert("Message Sent Successfully!");

                    // reset form
                    setForm({
                        name: "",
                        email: "",
                        phone: "",
                        subject: "",
                        note: "",
                    });

                    setLoading(false);
                })
                .catch((error) => {
                    console.error("EmailJS Error:", error);
                    alert("Failed to send message. Please try again.");
                    setLoading(false);
                });
        } else {
            validator.current.showMessages();
            forceUpdate(1);
        }
        console.log({
            service: "service_xxx",
            template: "template_xxx",
            publicKey: "public_xxx",
            data: form
        });
    };

    return (
        <form onSubmit={handleSubmit} className="contact-validation-active">

            {/* NAME */}
            <div>
                <label>Name*</label>
                <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                />
                {validator.current.message("name", form.name, "required|alpha_space")}
            </div>

            {/* EMAIL */}
            <div>
                <label>Email*</label>
                <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                />
                {validator.current.message("email", form.email, "required|email")}
            </div>

            {/* PHONE */}
            <div>
                <label>Phone*</label>
                <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={form.phone}
                    onChange={handlePhoneChange}
                    maxLength={10}
                    inputMode="numeric"
                    placeholder="10 digit mobile number"
                />
                {validator.current.message("phone", form.phone, "required|min:10|max:10")}
            </div>

            {/* SUBJECT */}
            <div>
                <label>Subject*</label>
                <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                />
                {validator.current.message("subject", form.subject, "required")}
            </div>

            {/* MESSAGE */}
            <div className="fullwidth">
                <label>Message*</label>
                <textarea
                    className="form-control"
                    name="note" // ✅ FIXED
                    value={form.note}
                    onChange={handleChange}
                />
                {validator.current.message("message", form.note, "required|min:10")}
            </div>

            {/* SUBMIT */}
            <div className="submit-area">
                <button type="submit" className="shop-btn" disabled={loading}>
                    {loading ? "Sending..." : "Send Message"}
                </button>
            </div>
        </form>
    );
};

export default ContactForm;